import { call, put, takeEvery } from 'redux-saga/effects';
import { CreateNewDealerCustomer, newDealerActionCreators, NewDealerActionKeys } from '../';
import { IEntityWithMessages } from '../../../services/HttpService';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { processMessages, showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import * as api from '../newDealerApi';
import { INewDealerRequestFull } from '../newDealerInterfaces';

function* importNewDealerOrdersSaga(action: CreateNewDealerCustomer) {
  yield put(uiActionCreators.showSpinnerDialog());

  const response: IApiExecuteRespone<IEntityWithMessages<INewDealerRequestFull>> = yield call(
    api.importNewDealerOrders,
    action.payload.newDealerRequestId
  );

  if (!response.requestFailed && response.value) {
    yield processMessages(response.value);
    if (response.value.value) {
      yield put(newDealerActionCreators.setRequest(response.value.value));
    }
  } else {
    yield showFailedRequestDialog(response);
  }

  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchImportNewDealerOrders() {
  yield takeEvery(NewDealerActionKeys.IMPORT_NEW_DEALER_ORDERS, importNewDealerOrdersSaga);
}
